import React from 'react';
import { Text } from '@common-fe/common-fe';

const Invoices = () => (
  <Text>Invoices</Text>
);

export default Invoices;
